import { Card, CardContent, CardHeader, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import LeftBox from './LeftBox';

const propTypes = {};
const defaultProps = {};

const useStyles = makeStyles((theme) => ({
    title: {
        background: theme.palette.background.default,
    },
}));

function TodayBox({ items }) {
    const classes = useStyles();

    return (
        <Card elevation={10}>
            <CardHeader title="What's happening today?" className={classes.title} />

            <CardContent>
                <Grid container justify="space-between">
                    <LeftBox
                        item={{ today: items.user.today, yesterday: items.user.yesterday }}
                        label="NEW USER"
                    />
                    <LeftBox
                        item={{ today: items.order.today, yesterday: items.order.yesterday }}
                        label="ORDER"
                    />
                    <LeftBox
                        item={{ today: items.transaction.today, yesterday: items.transaction.yesterday }}
                        label="TRANSACTION (Rp.)"
                    />

                </Grid>
            </CardContent>
        </Card>
    );
}

TodayBox.propTypes = propTypes;
TodayBox.defaultProps = defaultProps;

export default TodayBox;
